import React, { useEffect, useState, Fragment, useRef } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import {
    Grid, Typography, Zoom, Table, TableBody, TableHead, 
    TableCell, TableRow, Button, RadioGroup, Radio, FormControlLabel, FormControl, FormLabel, Checkbox
} from '@material-ui/core/'
import { authFetch, logout } from '../../auth';
import ReactToPrint from 'react-to-print';
import getPeriods from '../../const/yearPeriods';
import PrintIcon from '@material-ui/icons/Print';
import specLogo from '../../speclogo.jpg'

const StyledTableCellHeader = withStyles((theme) => ({
    head: {
        backgroundColor: 'white',
        color: 'black',
        padding: 2,
        fontFamily: 'arial',
        border: '1px solid black',
        fontSize: 7,
        minHeight: 15
    },
    body: {
        fontSize: 14,
        color: theme.palette.primary.dark,
        padding: 5,
        fontFamily: 'arial',
        border: '1px solid black'
    },
}))(TableCell);

const StyledTableCellHeaderComp = withStyles((theme) => ({
    head: {
        backgroundColor: 'white',
        color: 'black',
        padding: 2,
        fontFamily: 'arial',
        border: '1px solid black',
        fontSize: 8, 
        textAlign: 'center'       
    },
    body: {
        fontSize: 14,
        color: theme.palette.primary.dark,
        padding: 5,
        fontFamily: 'arial',
        border: '1px solid black'
    },
}))(TableCell);

const StyledTableCellHeaderTitle = withStyles((theme) => ({
    head: {
        backgroundColor: 'white',
        color: 'black',
        padding: 2,
        fontFamily: 'arial',
        border: '1px solid black',
        fontSize: 7,                
    },
    body: {
        fontSize: 14,
        color: theme.palette.primary.dark,
        padding: 5,
        fontFamily: 'arial',
        border: '1px solid black'
    },
}))(TableCell);

const StyledTableCellBody = withStyles((theme) => ({
    head: {
        backgroundColor: 'white',
        color: 'black',
        padding: 0,
        fontFamily: 'arial',
        border: '1px solid black',
        fontSize: 8,    
        textAlign: 'center'                    
    },
    body: {
        backgroundColor: 'white',
        color: 'black',
        padding: 0,
        fontFamily: 'arial',
        border: '1px solid black',
        fontSize: 8,    
        textAlign: 'center'        
    },
}))(TableCell);

const StyledTableCellHeaderTitleCedenar = withStyles((theme) => ({
    head: {
        backgroundColor: 'white',
        color: 'black',
        padding: 2,
        fontFamily: 'arial',
        border: '1px solid black',
        fontSize: 14, 
        textAlign: 'center',
        fontWeight: 'bold'              
    },
    body: {
        fontSize: 11,
        color: 'black',
        padding: 2,
        fontFamily: 'arial',
        border: '1px solid black',
        textAlign: 'center'
    },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: theme.spacing(2)
    },
    sectionTitle: {
        marginBottom: 10,
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 3,
        color: theme.palette.primary.dark
    },
    buttonActions: {
        marginTop: 20,
        marginBottom: 20,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: theme.spacing(3)
    },
    decimalGroup: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    }
}));

const levelsNames = { n1or: '1 OR', n1comp: '1 COMP', n1us: '1 US', n2: '2', n3: '3' };
const levelsIdx = { n1or: 0, n1comp: 1, n1us: 2, n2: 3, n3: 4 };

const formatVal = (val, decimalMode) => {
    if (val === null || val === undefined || val === '') return '-';
    const num = Number(val);
    if (isNaN(num)) return String(val);
    
    if (decimalMode === 'full') {
        return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 14 });
    } else if (decimalMode === '4') {
        return num.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 });
    }
    return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export default function TariffTree(props) {
    const classes = useStyles();
    const [cuPublicationTree, setCuPublicationTree] = useState({});  
    const [cuNoCotValues, setCuNoCotValues] = useState({});
    const [cuOTTree, setCuOTTree] = useState({}); 
    const [trCompValues, setTrCompValues] = useState({});
    const [rsCompValues, setRsCompValues] = useState({}); 
    const [cvCompValues, setCvCompValues] = useState({});
    const [cvNoCotValues, setCvNoCotValues] = useState({});
    const [grCompValues, setGrCompValues] = useState({});
    const [prCompValues, setPrCompValues] = useState({});
    const [dtCompValues, setDtCompValues] = useState({});
    const [cfmj, setCfmj] = useState({});
    const [cvr, setCvr] = useState({});
    const [cot, setCot] = useState({});
    const [sellLevels, setSellLevels] = useState({});
    const [subsidy, setSubsidy] = useState({});

    // Opciones: '2' | '4' | 'full'
    const [decimalPrecision, setDecimalPrecision] = useState('2');

    const monthPeriods = getPeriods(0);
    const publicationPdfRef = useRef(null);

    const monthIdx = Number(props.periodDate.getMonth() + 1) < 12 ? Number(props.periodDate.getMonth()) + 1 : 0;
    const year = Number(props.periodDate.getMonth() + 1) < 12 ? props.periodDate.getFullYear() : props.periodDate.getFullYear() + 1;    

    // Reglas CSS dinámicas para impresión
    const getPageStyle = () => {
        if (decimalPrecision === 'full' || decimalPrecision === '4') {
            return `
                @page {
                    size: landscape;
                    margin: 5mm;
                }
                @media print {
                    body {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    table {
                        font-size: 7px !important;
                        width: 100% !important;
                    }
                    th, td {
                        padding: 1px 2px !important;
                        font-size: 6.5px !important;
                        line-height: 1.1 !important;
                        white-space: nowrap !important;
                    }
                    p, span, div {
                        font-size: 7.5px !important;
                    }
                }
            `;
        }

        return `
            @page {
                size: portrait;
                margin: 8mm;
            }
            @media print {
                body {
                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                }
            }
        `;
    };

    const renderPublicationTree = () => (
        <div ref={publicationPdfRef} style={{ padding: 10, backgroundColor: 'white' }}>        
            <Grid container spacing={0} alignItems="center" justify="center">
                <Grid item xs={3}>                
                    <img src={specLogo} style={{ width: '85.5%', padding: 0, marginLeft: 10 }} title="" alt="" />  
                    <Typography align="center" variant="body2" style={{ fontWeight: 'bold', fontSize: 9, fontFamily: 'arial' }}>SPECTRUM RENOVAVEIS S.A.S. E.S.P</Typography>  
                    <Typography align="center" variant="body2" style={{ fontWeight: 'bold', fontSize: 9, fontFamily: 'arial' }}>NIT: 900.589.503-6</Typography>                                                                              
                </Grid>
                <Grid item xs={6}>
                    <Table>
                        <TableHead>                    
                            <StyledTableCellHeaderTitle colSpan={11}>COMPONENTES DEL COSTO UNITARIO DE PRESTACION DEL SERVICIO (CU)</StyledTableCellHeaderTitle>                        
                        </TableHead>
                        <TableHead>
                            <StyledTableCellHeader colSpan={11}>Tarifas Reguladas Res. CREG 119/07, 97/08, 105/09, 156/09, 180/14, 191/14 189/15, 199/16, 015/18, 010/20 012/20, 058/20. </StyledTableCellHeader>
                        </TableHead>
                        <TableHead>
                            <StyledTableCellHeaderComp>Tmax:</StyledTableCellHeaderComp>
                            <StyledTableCellHeaderComp style={{ width: '10%' }}>{formatVal(trCompValues['UNI']?.[0], decimalPrecision)}</StyledTableCellHeaderComp>
                            <StyledTableCellHeaderComp>Tmed:</StyledTableCellHeaderComp>
                            <StyledTableCellHeaderComp style={{ width: '10%' }}>{formatVal(trCompValues['UNI']?.[1], decimalPrecision)}</StyledTableCellHeaderComp>
                            <StyledTableCellHeaderComp>Tmin:</StyledTableCellHeaderComp>
                            <StyledTableCellHeaderComp style={{ width: '10%' }}>{formatVal(trCompValues['UNI']?.[2], decimalPrecision)}</StyledTableCellHeaderComp>
                            <StyledTableCellHeaderComp>Tmon:</StyledTableCellHeaderComp>
                            <StyledTableCellHeaderComp style={{ width: '10%' }}>{formatVal(trCompValues['UNI']?.[3], decimalPrecision)}</StyledTableCellHeaderComp>
                            <StyledTableCellHeaderComp>Rm:</StyledTableCellHeaderComp>
                            <StyledTableCellHeaderComp style={{ width: '10%' }}>{formatVal(rsCompValues['UNI']?.[0], decimalPrecision)}</StyledTableCellHeaderComp>
                            <StyledTableCellHeaderComp style={{ width: '16%' }}>{monthPeriods[monthIdx] + ' ' + year}</StyledTableCellHeaderComp>
                        </TableHead>
                    </Table>
                </Grid>
                <Grid item xs={3}>
                    <Table>
                        <TableHead>
                            <StyledTableCellHeader colSpan={9} style={{ height: 29 }}></StyledTableCellHeader>
                        </TableHead>
                        <TableHead>
                            <StyledTableCellHeader colSpan={9} style={{ height: 29 }}></StyledTableCellHeader>
                        </TableHead>
                        <TableHead>
                            <StyledTableCellHeader colSpan={3}>Cu Opc. Tarifaria Res. CREG 012 y 058 de 2020 </StyledTableCellHeader>                        
                        </TableHead>
                    </Table>
                </Grid>
                <Grid item xs={9}>
                    <Table>
                        <TableHead>
                            <StyledTableCellBody style={{ width: '14%' }}>MERCADO</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '6.5%' }}>Niv. Tensión</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>Gm</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>Cvm</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>Dm</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>PR MAX</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>PR MED</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>PR MIN</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>PR MON</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>Cu MAX</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>Cu MED</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>Cu MIN</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>Cu MON</StyledTableCellBody>                        
                        </TableHead>
                        <TableBody>
                            {props.markets.map((activeMarketName, activeMarketIdx) => (
                                sellLevels[activeMarketName]?.map((propertyLevel, propertyLevelIdx) => (
                                    <TableRow key={propertyLevelIdx}>
                                        <StyledTableCellBody style={{ width: '14%', fontWeight: propertyLevelIdx < 1 ? 'bold' : 'normal', height: 16 }}>
                                            {propertyLevelIdx < 1
                                                ? activeMarketName === 'BOGOTA - CUNDINAMARCA'
                                                    ? 'BOGOTA (Cund.)'
                                                    : activeMarketName === 'ANTIOQUIA'
                                                    ? 'MEDELLIN (Anti.)'
                                                    : activeMarketName.includes('CALI')
                                                    ? 'CALI YUMBO'
                                                    : activeMarketName
                                                : propertyLevelIdx === 1
                                                ? 'Cfm,j: ' + formatVal(cfmj[activeMarketName], decimalPrecision)
                                                : ''}
                                        </StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '6.5%', height: 16 }}>{levelsNames[propertyLevel]}</StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>{formatVal(grCompValues[activeMarketName]?.[0], decimalPrecision)}</StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>{formatVal(cvCompValues[activeMarketName]?.[0], decimalPrecision)}</StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>{formatVal(dtCompValues[activeMarketName]?.[levelsIdx[propertyLevel]], decimalPrecision)}</StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>{formatVal(prCompValues[activeMarketName]?.slice(0, 3)[levelsIdx[propertyLevel] <= 2 ? 0 : levelsIdx[propertyLevel] - 2], decimalPrecision)}</StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>{formatVal(prCompValues[activeMarketName]?.slice(3, 6)[levelsIdx[propertyLevel] <= 2 ? 0 : levelsIdx[propertyLevel] - 2], decimalPrecision)}</StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>{formatVal(prCompValues[activeMarketName]?.slice(6, 9)[levelsIdx[propertyLevel] <= 2 ? 0 : levelsIdx[propertyLevel] - 2], decimalPrecision)}</StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>{formatVal(prCompValues[activeMarketName]?.slice(9, 12)[levelsIdx[propertyLevel] <= 2 ? 0 : levelsIdx[propertyLevel] - 2], decimalPrecision)}</StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>{formatVal(cuPublicationTree[activeMarketName]?.['max']?.[propertyLevel], decimalPrecision)}</StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>{formatVal(cuPublicationTree[activeMarketName]?.['med']?.[propertyLevel], decimalPrecision)}</StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>{formatVal(cuPublicationTree[activeMarketName]?.['min']?.[propertyLevel], decimalPrecision)}</StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>{formatVal(cuPublicationTree[activeMarketName]?.['mon']?.[propertyLevel], decimalPrecision)}</StyledTableCellBody>
                                    </TableRow>
                                ))
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
                <Grid item xs={3}>
                    <Table>
                        <TableHead>                        
                            <StyledTableCellBody style={{ width: '5.5%' }}>Cu MAX</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>Cu MED</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>Cu MIN</StyledTableCellBody>
                            <StyledTableCellBody style={{ width: '5.5%' }}>Cu MON</StyledTableCellBody>                        
                        </TableHead>
                        <TableBody>
                            {props.markets.map((activeMarketName, activeMarketIdx) => (
                                sellLevels[activeMarketName]?.map((propertyLevel) => (
                                    <TableRow key={activeMarketIdx}>                                    
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>
                                            {JSON.parse(props.marketsOpTariff[activeMarketIdx])['levels'][levelsIdx[propertyLevel]] || activeMarketName in cuOTTree
                                                ? cuOTTree[activeMarketName]?.['max']?.[propertyLevel] > 0
                                                    ? formatVal(cuOTTree[activeMarketName]['max'][propertyLevel], decimalPrecision)
                                                    : ''
                                                : ''}
                                        </StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>
                                            {JSON.parse(props.marketsOpTariff[activeMarketIdx])['levels'][levelsIdx[propertyLevel]] || activeMarketName in cuOTTree
                                                ? cuOTTree[activeMarketName]?.['med']?.[propertyLevel] > 0
                                                    ? formatVal(cuOTTree[activeMarketName]['med'][propertyLevel], decimalPrecision)
                                                    : ''
                                                : ''}
                                        </StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>
                                            {JSON.parse(props.marketsOpTariff[activeMarketIdx])['levels'][levelsIdx[propertyLevel]] || activeMarketName in cuOTTree
                                                ? cuOTTree[activeMarketName]?.['min']?.[propertyLevel] > 0
                                                    ? formatVal(cuOTTree[activeMarketName]['min'][propertyLevel], decimalPrecision)
                                                    : ''
                                                : ''}
                                        </StyledTableCellBody>
                                        <StyledTableCellBody style={{ width: '5.5%', height: 16 }}>
                                            {JSON.parse(props.marketsOpTariff[activeMarketIdx])['levels'][levelsIdx[propertyLevel]] || activeMarketName in cuOTTree
                                                ? cuOTTree[activeMarketName]?.['mon']?.[propertyLevel] > 0
                                                    ? formatVal(cuOTTree[activeMarketName]['mon'][propertyLevel], decimalPrecision)
                                                    : ''
                                                : ''}
                                        </StyledTableCellBody>
                                    </TableRow>
                                ))
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
                <Grid item xs={12}>
                    <Table>
                        <TableHead>
                            <StyledTableCellHeaderTitle rowSpan={2} colSpan={11} style={{ textAlign: 'center', fontSize: 11, fontWeight: 'bold', padding: 0 }}>
                                NOTA: A los clientes sujetos al pago de contribución de solidaridad se le aplicara un porcentaje sobre la tarifa del CU: 20%: clientes comerciales e industriales con contribución; 0%: clientes exentos de contribución
                            </StyledTableCellHeaderTitle>
                        </TableHead>
                        <TableHead>
                            <StyledTableCellHeaderTitle colSpan={11}>{''}</StyledTableCellHeaderTitle>
                        </TableHead>
                    </Table>
                </Grid>
            </Grid>
        </div>
    );

    const renderCedenarPublicationTree = () => (
        <div ref={publicationPdfRef} style={{ padding: 10, marginTop: 40, backgroundColor: 'white' }}>
            <Grid container spacing={0} alignItems="center" justify="center">
                <Grid item xs={3}>                                        
                    <img style={{ padding: 0, width: '85.5%' }} src={"https://disponibilidad.cedenar.com.co/Imagenes/s5_logo.png"} title="" alt="" />                                                                                                
                </Grid>
                <Grid item xs={12}>
                    <Table>
                        <TableHead>    
                            <TableRow>
                                <StyledTableCellHeaderTitleCedenar colSpan={8} style={{ fontSize: 14, fontWeight: 'bold' }}>Costo Unitario Según Resolucion CREG-119-07</StyledTableCellHeaderTitleCedenar>                        
                                <StyledTableCellHeaderTitleCedenar rowSpan={year < 2024 ? 2 : 1} colSpan={3} style={{ color: 'green', fontSize: 14 }}>
                                    {year < 2024 ? 'Cu Opción tarifaria (Res. 12/2020)' : 'Cu (Res. 101-028 de 2023)'}
                                </StyledTableCellHeaderTitleCedenar>
                            </TableRow>                
                            <TableRow>
                                <StyledTableCellHeaderTitleCedenar style={{ width: '24%' }}>Nivel de Tension y Tipo Propiedad</StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>Gm,i,j </StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>Tm</StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>Dn,m</StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>
                                    Cvm,i,j {year < 2024 ? '' : ' (SIN COT)'}
                                </StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>PR</StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>Rm,i</StyledTableCellHeaderTitleCedenar>     
                                <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>CU 119-07</StyledTableCellHeaderTitleCedenar>
                                {year < 2024 ? null : (
                                    <Fragment>
                                        <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>CvR <br /> (CON COT)</StyledTableCellHeaderTitleCedenar>
                                        <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>Cvm,i,j (CON COT)</StyledTableCellHeaderTitleCedenar>
                                        <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>Cu</StyledTableCellHeaderTitleCedenar>
                                    </Fragment>
                                )}
                            </TableRow> 
                        </TableHead>                    
                        <TableBody>
                            {['Nivel Tension 1- Propiedad:' + (props.username === 'Cedenar' ? 'CEDENAR' : 'OR'), 'Nivel Tension 1- Propiedad:COMPARTIDA', 'Nivel Tension 1- Propiedad:USUARIO', 'Nivel Tension 2', 'Nivel Tension 3'].map((level, idx) => (
                                <TableRow key={idx}>
                                    <StyledTableCellHeaderTitleCedenar style={{ width: '24%' }}>{level}</StyledTableCellHeaderTitleCedenar>
                                    <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>{formatVal(grCompValues['NARIÑO']?.[0], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                    <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>{formatVal(trCompValues['UNI']?.[3], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                    <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>{formatVal(dtCompValues['NARIÑO']?.[idx], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                    <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>
                                        {year < 2024 
                                            ? formatVal(cvCompValues['NARIÑO']?.[0], decimalPrecision)
                                            : cvCompValues['NARIÑO']?.length > 1 && Object.keys(cot).includes('NARIÑO')
                                            ? formatVal(idx < 3 ? cvNoCotValues['NARIÑO']?.[0] : cvNoCotValues['NARIÑO']?.[idx - 2], decimalPrecision)
                                            : '-'}
                                    </StyledTableCellHeaderTitleCedenar>
                                    <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>{formatVal(prCompValues['NARIÑO']?.[idx < 3 ? 9 : 9 + (idx - 2)], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                    <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>{formatVal(rsCompValues['UNI']?.[0], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>     
                                    <StyledTableCellHeaderTitleCedenar style={{ width: '7%' }}>
                                        {year < 2024
                                            ? formatVal(cuPublicationTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[idx]], decimalPrecision)
                                            : Object.keys(cot).includes('NARIÑO')
                                            ? formatVal(cuNoCotValues['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[idx]], decimalPrecision)
                                            : '-'}
                                    </StyledTableCellHeaderTitleCedenar>
                                    {year < 2024 ? (
                                        <StyledTableCellHeaderTitleCedenar>
                                            {Object.keys(cuOTTree).length > 0 ? formatVal(cuOTTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[idx]], decimalPrecision) : '-'}
                                        </StyledTableCellHeaderTitleCedenar> 
                                    ) : (
                                        <Fragment>
                                            <StyledTableCellHeaderTitleCedenar>
                                                {cvCompValues['NARIÑO']?.length > 1 && Object.keys(cvr).includes('NARIÑO')
                                                    ? formatVal(idx < 3 ? cvr['NARIÑO']?.[0] : cvr['NARIÑO']?.[idx - 2], decimalPrecision)
                                                    : '-'}
                                            </StyledTableCellHeaderTitleCedenar>
                                            <StyledTableCellHeaderTitleCedenar>
                                                {cvCompValues['NARIÑO']?.length > 1
                                                    ? formatVal(idx < 3 ? cvCompValues['NARIÑO']?.[0] : cvCompValues['NARIÑO']?.[idx - 2], decimalPrecision)
                                                    : '-'}
                                            </StyledTableCellHeaderTitleCedenar>
                                            <StyledTableCellHeaderTitleCedenar>
                                                {formatVal(cuPublicationTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[idx]], decimalPrecision)}
                                            </StyledTableCellHeaderTitleCedenar>
                                        </Fragment>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    <Typography style={{ margin: 20, fontSize: 14, fontWeight: 'bold', fontFamily: 'arial' }}>TARIFAS RESIDENCIALES</Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 14, width: '24%', fontWeight: 'bold', borderLeftColor: 'white', borderTopColor: 'white' }}></StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar colSpan={2} style={{ fontSize: 14, width: '15%', fontWeight: 'bold' }}>Estrato 1</StyledTableCellHeaderTitleCedenar>   
                                <StyledTableCellHeaderTitleCedenar colSpan={2} style={{ fontSize: 14, width: '15%', fontWeight: 'bold' }}>Estrato 2</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar colSpan={2} style={{ fontSize: 14, width: '15%', fontWeight: 'bold' }}>Estrato 3</StyledTableCellHeaderTitleCedenar>                      
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 14, width: '15%', fontWeight: 'bold' }}>Estrato 4</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 14, width: '15%', fontWeight: 'bold' }}>Estratos 5 y 6</StyledTableCellHeaderTitleCedenar> 
                            </TableRow> 
                            <TableRow>                            
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 14, width: '24%', fontWeight: 'bold' }}>Propiedad del activo</StyledTableCellHeaderTitleCedenar>   
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 14, fontWeight: 'bold' }}>% de subsidio</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 14, fontWeight: 'bold' }}>Tarifa con subsidio</StyledTableCellHeaderTitleCedenar>                      
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 14, fontWeight: 'bold' }}>% de subsidio</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 14, fontWeight: 'bold' }}>Tarifa con subsidio</StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 14, fontWeight: 'bold' }}>% de subsidio</StyledTableCellHeaderTitleCedenar>   
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 14, fontWeight: 'bold' }}>Tarifa con subsidio</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 14, fontWeight: 'bold' }}>Igual al costo unitario</StyledTableCellHeaderTitleCedenar>                      
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 14, fontWeight: 'bold' }}>Costo Unit. más 20% de Contribución</StyledTableCellHeaderTitleCedenar>                                             
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {['De ' + (props.username === 'Cedenar' ? 'CEDENAR' : 'OR'), 'Compartida', 'Del usuario'].map((level, idx) => (
                                <TableRow key={idx}>
                                    <StyledTableCellHeaderTitleCedenar>{level}</StyledTableCellHeaderTitleCedenar>
                                    <StyledTableCellHeaderTitleCedenar>{formatVal(subsidy['NARIÑO']?.['res']?.['prc_' + sellLevels['NARIÑO']?.[idx] + '_es1'], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                    <StyledTableCellHeaderTitleCedenar>{formatVal(subsidy['NARIÑO']?.['res']?.[sellLevels['NARIÑO']?.[idx] + '_es1'], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                    <StyledTableCellHeaderTitleCedenar>{formatVal(subsidy['NARIÑO']?.['res']?.['prc_' + sellLevels['NARIÑO']?.[idx] + '_es2'], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                    <StyledTableCellHeaderTitleCedenar>{formatVal(subsidy['NARIÑO']?.['res']?.[sellLevels['NARIÑO']?.[idx] + '_es2'], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                    <StyledTableCellHeaderTitleCedenar>{formatVal(subsidy['NARIÑO']?.['res']?.['prc_' + sellLevels['NARIÑO']?.[idx] + '_es3'], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                    <StyledTableCellHeaderTitleCedenar>{formatVal(subsidy['NARIÑO']?.['res']?.[sellLevels['NARIÑO']?.[idx] + '_es3'], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>     
                                    <StyledTableCellHeaderTitleCedenar>
                                        {year < 2024
                                            ? formatVal(cuOTTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[idx]], decimalPrecision)
                                            : formatVal(cuPublicationTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[idx]], decimalPrecision)}
                                    </StyledTableCellHeaderTitleCedenar> 
                                    <StyledTableCellHeaderTitleCedenar>{formatVal(subsidy['NARIÑO']?.['res']?.[sellLevels['NARIÑO']?.[idx] + '_es56'], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    <Typography style={{ margin: 20, fontSize: 14, fontWeight: 'bold', fontFamily: 'arial' }}>TARIFAS NO RESIDENCIALES</Typography>
                </Grid>
                <Grid item xs={6} style={{ textAlign: 'center' }}>                
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableCellHeaderTitleCedenar colSpan={6} style={{ fontSize: 14, width: '24%', fontWeight: 'bold' }}>OFICIAL Y ESPECIAL</StyledTableCellHeaderTitleCedenar>                         
                            </TableRow> 
                            <TableRow>                                                                         
                                <StyledTableCellHeaderTitleCedenar colSpan={3} style={{ fontSize: 11, fontWeight: 'bold' }}>NIVEL DE TENSION 1</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar rowSpan={2} style={{ fontSize: 11, fontWeight: 'bold' }}>NIVEL DE TENSION 2</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar rowSpan={2} style={{ fontSize: 11, fontWeight: 'bold' }}>NIVEL DE TENSION 3</StyledTableCellHeaderTitleCedenar>                                                                                                                
                            </TableRow>
                            <TableRow>                                                                         
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 11, fontWeight: 'bold' }}>CEDENAR</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 11, fontWeight: 'bold' }}>COMPARTIDA</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 11, fontWeight: 'bold' }}>USUARIO</StyledTableCellHeaderTitleCedenar>                                                                                                                
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>                                        
                                <StyledTableCellHeaderTitleCedenar>
                                    {year < 2024
                                        ? formatVal(cuOTTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[0]], decimalPrecision)
                                        : formatVal(cuPublicationTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[0]], decimalPrecision)}
                                </StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar>
                                    {year < 2024
                                        ? formatVal(cuOTTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[1]], decimalPrecision)
                                        : formatVal(cuPublicationTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[1]], decimalPrecision)}
                                </StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar>
                                    {year < 2024
                                        ? formatVal(cuOTTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[2]], decimalPrecision)
                                        : formatVal(cuPublicationTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[2]], decimalPrecision)}
                                </StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar>
                                    {year < 2024
                                        ? formatVal(cuOTTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[3]], decimalPrecision)
                                        : formatVal(cuPublicationTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[3]], decimalPrecision)}
                                </StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar>
                                    {year < 2024
                                        ? formatVal(cuOTTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[4]], decimalPrecision)
                                        : formatVal(cuPublicationTree['NARIÑO']?.['mon']?.[sellLevels['NARIÑO']?.[4]], decimalPrecision)}
                                </StyledTableCellHeaderTitleCedenar>                                       
                            </TableRow>                                
                        </TableBody>
                    </Table>
                </Grid>
               
                <Grid item xs={6} style={{ textAlign: 'center' }}>                
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableCellHeaderTitleCedenar colSpan={6} style={{ fontSize: 14, width: '24%', fontWeight: 'bold' }}>COMERCIAL - INDUSTRIAL y PROVISIONAL</StyledTableCellHeaderTitleCedenar>                         
                            </TableRow> 
                            <TableRow>                                                                         
                                <StyledTableCellHeaderTitleCedenar colSpan={3} style={{ fontSize: 11, fontWeight: 'bold' }}>NIVEL DE TENSION 1</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar rowSpan={2} style={{ fontSize: 11, fontWeight: 'bold' }}>NIVEL DE TENSION 2</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar rowSpan={2} style={{ fontSize: 11, fontWeight: 'bold' }}>NIVEL DE TENSION 3</StyledTableCellHeaderTitleCedenar>                                                                                                                
                            </TableRow>
                            <TableRow>                                                                         
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 11, fontWeight: 'bold' }}>CEDENAR</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 11, fontWeight: 'bold' }}>COMPARTIDA</StyledTableCellHeaderTitleCedenar> 
                                <StyledTableCellHeaderTitleCedenar style={{ fontSize: 11, fontWeight: 'bold' }}>USUARIO</StyledTableCellHeaderTitleCedenar>                                                                                                                
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>                                        
                                <StyledTableCellHeaderTitleCedenar>{formatVal(subsidy['NARIÑO']?.['res']?.[sellLevels['NARIÑO']?.[0] + '_es56'], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar>{formatVal(subsidy['NARIÑO']?.['res']?.[sellLevels['NARIÑO']?.[1] + '_es56'], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar>{formatVal(subsidy['NARIÑO']?.['res']?.[sellLevels['NARIÑO']?.[2] + '_es56'], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar>{formatVal(subsidy['NARIÑO']?.['res']?.['esp_n2'], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>
                                <StyledTableCellHeaderTitleCedenar>{formatVal(subsidy['NARIÑO']?.['res']?.['esp_n3'], decimalPrecision)}</StyledTableCellHeaderTitleCedenar>                                       
                            </TableRow>                                
                        </TableBody>
                    </Table>
                </Grid>
            </Grid>
        </div>
    );

    useEffect(() => {
        let username = props.username;
        let year = Number(props.periodDate.getMonth() + 1) < 12 ? props.periodDate.getFullYear() : props.periodDate.getFullYear() + 1;
        let period = Number(props.periodDate.getMonth() + 1) < 12 ? Number(props.periodDate.getMonth() + 1) + 1 : 1;
        let version = props.tariffCalcVersion;
        let usernameCode = username.slice(0, 3);
        document.title = "Publicación tarifaria " + String(year) + '-' + (String(period).length > 1 ? String(period) : '0' + String(period));        
        
        if (props.tariffsPublished) {
            authFetch("/api/get-publication-tree?electric_tariff_id=" + String(usernameCode + String(String(year) + String(period) + version)) +
                "&username=" + username + "&market=" + props.market +
                "&user_type=" + props.userType +
                "&decimal_precision=" + String(decimalPrecision)
            ).then(response => {
                if (response.status === 422) {
                    logout();
                    return null;
                }
                return response.json();
            }).then(response => {
                if (response && response.cuGeneral) {
                    setCuPublicationTree(response.cuGeneral);
                    setCuNoCotValues(response.cuNoCot);
                    setCuOTTree(response.cuOpTariff);
                    setTrCompValues(response.trValues);
                    setRsCompValues(response.rsValues);
                    setCvCompValues(response.cvValues);
                    setCvNoCotValues(response.cvNoCot);
                    setGrCompValues(response.grValues);
                    setPrCompValues(response.prValues);
                    setDtCompValues(response.dtValues);
                    setCfmj(response.cfmj);
                    setCvr(response.cvrValues);
                    setCot(response.cotValues);
                    setSellLevels(response.levels);
                    if (props.username === 'Cedenar' || props.username === 'Demo') {
                        setSubsidy(response.subsidy);
                    }                
                }
            });
        }
    }, [props.periodDate, props.tariffCalcVersion, props.market, props.tariffsPublished, decimalPrecision]);

    const isSpectrum = props.tariffsPublished && Object.keys(trCompValues).length > 0 && Object.keys(rsCompValues).length > 0 
        && Object.keys(cvCompValues).length > 0 && Object.keys(dtCompValues).length > 0 && Object.keys(grCompValues).length > 0
        && Object.keys(prCompValues).length > 0 && Object.keys(sellLevels).length > 0 && Object.keys(cuPublicationTree).length > 0 
        && props.markets.length > 0 && Object.keys(cuOTTree).length > 0 && Object.keys(cfmj).length > 0 && props.username === 'SPECTRUM';

    const isCedenarOrDemo = props.tariffsPublished && Object.keys(trCompValues).length > 0 && Object.keys(rsCompValues).length > 0 
        && Object.keys(cvCompValues).length > 0 && Object.keys(dtCompValues).length > 0 && Object.keys(grCompValues).length > 0
        && Object.keys(prCompValues).length > 0 && Object.keys(sellLevels).length > 0 && Object.keys(cuPublicationTree).length > 0 
        && (Object.keys(cuOTTree).length > 0 || Number(year) >= 2024) && (props.username === 'Cedenar' || props.username === 'Demo') && Object.keys(subsidy).length > 0;

    const renderDecimalSelector = () => (
        <div className={classes.decimalGroup}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={decimalPrecision === '2'}
                        onChange={() => setDecimalPrecision('2')}
                        color="primary"
                    />
                }
                label="Redondeadas a 2"
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={decimalPrecision === '4'}
                        onChange={() => setDecimalPrecision('4')}
                        color="primary"
                    />
                }
                label="Redondeadas a 4"
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={decimalPrecision === 'full'}
                        onChange={() => setDecimalPrecision('full')}
                        color="primary"
                    />
                }
                label="Toda la cola decimal"
            />
        </div>
    );

    return (
        <div className={classes.root}>            
            <Grid container justify="center">
                <Zoom in timeout={700}>
                    <Grid item xs={12}>
                        {props.tariffCalcVersion === '' ? (                                                                                
                            <Typography variant="subtitle1" className={classes.sectionTitle}>
                                No se ha generado una versión de cálculo para el periodo actual.
                            </Typography>
                        ) : isSpectrum ? (
                            <Fragment>
                                <Typography variant="subtitle1" className={classes.sectionTitle}>
                                    Publicación tarifaria - SPECTRUM
                                </Typography>
                                
                                {renderPublicationTree()}
                                
                                <div className={classes.buttonActions}>
                                    <ReactToPrint
                                        pageStyle={getPageStyle()}
                                        trigger={() => 
                                            <Button color='primary' variant='contained' startIcon={<PrintIcon />}>
                                                Imprimir
                                            </Button>
                                        }
                                        content={() => publicationPdfRef.current}
                                    /> 
                                    {renderDecimalSelector()}
                                </div>
                            </Fragment>
                        ) : isCedenarOrDemo ? (
                            <Fragment>
                                <Typography variant="subtitle1" className={classes.sectionTitle}>
                                    Publicación tarifaria - {props.username}
                                </Typography>
                                
                                {renderCedenarPublicationTree()}

                                <div className={classes.buttonActions}>
                                    <ReactToPrint
                                        pageStyle={getPageStyle()}
                                        trigger={() => 
                                            <Button color='primary' variant='contained' startIcon={<PrintIcon />}>
                                                Imprimir
                                            </Button>
                                        }
                                        content={() => publicationPdfRef.current}
                                    /> 
                                    {renderDecimalSelector()}
                                </div>
                            </Fragment>
                        ) : (
                            <Typography variant="subtitle1" className={classes.sectionTitle}>
                                Las tarifas de todos los mercados no han sido publicadas.
                            </Typography>                        
                        )}          
                    </Grid>
                </Zoom>
            </Grid>                                     
        </div>
    );
}